export default {
  pageNotFound: 'The page you are looking for does not exist.',
  generic: {
    title: 'Something unexpected has happened',
    subtitle: 'Looks like you got lost along the way',
  },
  newApplication: 'Start new application',
};
